import React from "react"
import { Modal } from "@mimber/ui-web"
import { ContactSupportForm } from "@/components/forms/ContactSupportForm"
import type { ContactSupportModalProps } from "./ContactSupportModal.types"

/**
 * Modal component for submitting a "Contact Support" request.
 * Uses the ui-web Modal wrapper with render props pattern.
 */
export const ContactSupportModal: React.FunctionComponent<
  ContactSupportModalProps
> = ({ onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Contact Support" {...modalProps}>
      {(close) => (
        <ContactSupportForm
          onSuccess={() => {
            close()
            onSuccess?.()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
